import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import previouslyPurchasedQuery from './query'
import {
  IPreviouslyPurchasedVariables,
  IPreviouslyPurchasedResponse,
} from './types'

/**
 * Hook declaration to obtain a lazy query of previously purchased products.
 * @param options: LazyQueryHookOptions
 * @internal
 */
const useLazyPreviouslyPurchased = (
  options?: LazyQueryHookOptions<
    IPreviouslyPurchasedResponse,
    IPreviouslyPurchasedVariables
  >,
) => {
  return useLazyQuery<
    IPreviouslyPurchasedResponse,
    IPreviouslyPurchasedVariables
  >(previouslyPurchasedQuery, {
    ...options,
    fetchPolicy: 'no-cache',
  })
}

export { useLazyPreviouslyPurchased }
